__turbopack_context__.v({
  "className": "noto_serif_8f33990a-module__GG231W__className",
  "variable": "noto_serif_8f33990a-module__GG231W__variable",
});
